var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitDetailsHeartIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#ED2024",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#ED2024"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7587 12.7584L16.3794 12.4136L20.0001 14.8274L23.6208 12.4136L27.2415 12.7584L27.5863 16.8963L27.2415 21.0343L20.0001 26.5515L12.7587 21.0343L12.0691 16.8963L12.7587 12.7584Z",
    fill: "#ED2024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8851 28.253L18.5518 27.0576C17.0039 25.6629 15.7242 24.4599 14.7127 23.4484C13.7012 22.4369 12.8966 21.5288 12.2989 20.7242C11.7012 19.9196 11.2836 19.1802 11.046 18.5058C10.8085 17.8315 10.6897 17.1418 10.6897 16.4369C10.6897 14.9963 11.1725 13.7932 12.138 12.8277C13.1035 11.8622 14.3066 11.3794 15.7472 11.3794C16.5441 11.3794 17.3027 11.548 18.023 11.8851C18.7433 12.2223 19.364 12.6974 19.8851 13.3104C20.4062 12.6974 21.0269 12.2223 21.7472 11.8851C22.4675 11.548 23.2261 11.3794 24.023 11.3794C25.4636 11.3794 26.6667 11.8622 27.6322 12.8277C28.5977 13.7932 29.0805 14.9963 29.0805 16.4369C29.0805 17.1418 28.9617 17.8315 28.7242 18.5058C28.4866 19.1802 28.069 19.9196 27.4713 20.7242C26.8736 21.5288 26.069 22.4369 25.0575 23.4484C24.046 24.4599 22.7663 25.6629 21.2184 27.0576L19.8851 28.253ZM19.8851 25.7702C21.3564 24.4522 22.5671 23.3219 23.5173 22.3794C24.4675 21.4369 25.2184 20.6169 25.7702 19.9196C26.3219 19.2223 26.705 18.6016 26.9196 18.0576C27.1341 17.5135 27.2414 16.9733 27.2414 16.4369C27.2414 15.5173 26.9349 14.751 26.3219 14.138C25.7089 13.525 24.9426 13.2185 24.023 13.2185C23.3027 13.2185 22.6361 13.4215 22.023 13.8277C21.41 14.2338 20.9885 14.751 20.7587 15.3794H19.0115C18.7817 14.751 18.3602 14.2338 17.7472 13.8277C17.1341 13.4215 16.4675 13.2185 15.7472 13.2185C14.8276 13.2185 14.0613 13.525 13.4483 14.138C12.8353 14.751 12.5288 15.5173 12.5288 16.4369C12.5288 16.9733 12.6361 17.5135 12.8506 18.0576C13.0652 18.6016 13.4483 19.2223 14 19.9196C14.5518 20.6169 15.3027 21.4369 16.2529 22.3794C17.2031 23.3219 18.4138 24.4522 19.8851 25.7702Z",
    fill: "#ED2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitDetailsHeartIconActive);
export default __webpack_public_path__ + "static/media/unit-details-heart-icon-active.8d43a8141b36e003de9130facffa6ac8.svg";
export { ForwardRef as ReactComponent };